//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "TextArea",
  props: {
    type: {
      type: String,
      default: "text"
    },
    searchInput: {
      type: Boolean,
      default: false
    },
    readOnly: {
      default: false
    },
    borderless: {
      default: false
    },
    inverted: {
      default: false
    },
    refs: {
      type: String
    },
    rules: {},
    label: {
      type: String
    },
    value: {},
    mask: {
      type: String
    },
    fillmask: {
      type: String
    },
    suffix: {
      type: String
    },
    prefix: {
      type: String
    },
    outlined: {
      type: Boolean,
      default: true
    },
    filled: {
      type: Boolean
    },
    color: {
      type: String,
      default: "blue"
    },
    BGColor: {
      type: String,
      default: "white"
    },
    size: {
      type: String,
      default: "10px"
    },
    dense: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: false
    },
    autogrow: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean
    },
    tooltip: {
      type: Boolean
    },
    toolValue: {
      type: String,
      default: "Add toolValue prop to change text"
    },
    hint: {
      type: String
    },
    inputStyle: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    errorValidation: {
      type: String
    }
  },
  data: function data() {
    return {
      originalValue: null
    };
  },
  mounted: function mounted() {
    this.originalValue = this.value;
  },
  computed: {
    isOutlined: function isOutlined() {
      if (this.readOnly) {
        return false;
      } else return this.outlined;
    },
    isBorderless: function isBorderless() {
      if (this.readOnly) {
        return true;
      } else return this.borderless;
    },
    isDirty: function isDirty() {
      return this.value != "" && this.value != this.originalValue;
    }
  },
  methods: {
    isRequired: function isRequired() {
      if (this.required) {
        if (!this.value) return "*Field is required";else return true;
      } else return true;
    },
    resetDirty: function resetDirty() {
      this.originalValue = this.value;
      this.$refs.input.isDirty = false;
    }
  }
};